import { memo, useContext, useEffect } from "react";
import { useFormState } from "react-hook-form";

import { DialogLeaveWarningContext } from "./EdmDialog";

/*
  This can be used inside a SimpleForm that is inside an EdmDialog component
  It will cause the dialog to show a warning on close if there have been form changes
*/
export default memo(function DialogContextFormDirtyChecker() {
  const { isDirty, isSubmitted, isSubmitting } = useFormState();
  const { setFormIsDirty } = useContext(DialogLeaveWarningContext);

  useEffect(() => {
    if (isSubmitted || isSubmitting) {
      return setFormIsDirty(false);
    }
    if (isDirty) {
      return setFormIsDirty(true);
    }
  }, [isDirty, isSubmitted, isSubmitting, setFormIsDirty]);

  useEffect(() => {
    if (!isDirty || isSubmitted || isSubmitting) return;

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = "";
    };

    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [isDirty, isSubmitted, isSubmitting]);

  return null;
});
